import React, { useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';

import { BaseModal } from './index';
import { updatePassword } from '../../../lib/api';
import { getSessionId } from '../../../lib/storage';

import tr from '../../../../translations';

const ChangePasswordModal = ({ show, onClose }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [waiting, setWaiting] = useState(false);

  const handleSave = async (evt) => {
    evt.preventDefault();

    try {
      setWaiting(true);

      if (!oldPassword) {
        alert(tr('changePassword.error.oldPassword'));
        return false;
      }

      if (newPassword.length < 8) {
        alert(tr('changePassword.error.tooShort'));
        return false;
      }

      if (newPassword !== passwordConfirm) {
        alert(tr('changePassword.error.noMatch'));
        return false;
      }

      await updatePassword(oldPassword, newPassword, getSessionId());
      setOldPassword('');
      setNewPassword('');
      setPasswordConfirm('');
      onClose(true);
    } catch (ex) {
      alert(ex.message + " " + (ex.fields.password ? ex.fields.password: ""));
    } finally {
      setWaiting(false);
    }
  };

  const handleClose = () => {
    setOldPassword('');
    setNewPassword('');
    setPasswordConfirm('');
    onClose(false);
  };

  return (
    <BaseModal
      title={tr('changePassword.title')}
      show={show}
      waiting={waiting}
      onClose={handleClose}
      onSave={handleSave}
    >
      {tr('changePassword.oldPassword-label')}
      <InputGroup className="mb-3">
        <FormControl
          aria-label="current password"
          placeholder={tr('changePassword.oldPassword-placeholder')}
          type="password"
          value={oldPassword}
          onChange={({ target: { value } }) => setOldPassword(value)}
        />
      </InputGroup>
      {tr('changePassword.newPassword-label')}
      <InputGroup className="mb-3">
        <FormControl
          aria-label="new password"
          placeholder={tr('changePassword.newPassword-placeholder')}
          type="password"
          value={newPassword}
          onChange={({ target: { value } }) => setNewPassword(value)}
        />
      </InputGroup>
      {tr('changePassword.confirmPassword-label')}
      <InputGroup className="mb-3">
        <FormControl
          aria-label="confirm new password"
          placeholder={tr('changePassword.confirmPassword-placeholder')}
          type="password"
          value={passwordConfirm}
          onChange={({ target: { value } }) => setPasswordConfirm(value)}
        />
      </InputGroup>
    </BaseModal>
  );
};

export default ChangePasswordModal;
